var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('policy-table',{attrs:{"title":'API POLICY'},on:{"newPolicyEvent":_vm.createPolicyEvent,"editPolicyEvent":function($event){return _vm.updatePolicyEvent($event)}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }